import { all, call, put, takeLatest } from "redux-saga/effects";
import { request } from "@app/services";

import * as endpoints from "./endpoints";
import {
  carValuation,
  carValuationFailed,
  carValuationSuccess,
} from "./slices";

//---------------------------------------------

function* carValuationSaga({ payload }: ReturnType<typeof carValuation>): any {
  const { carNumber, phone } = payload as any;
  try {
    const response = yield call(request.post, endpoints.CarEvaluation, {
      licensePlateNumber: carNumber,
      phoneNumber: phone,
    });
    yield put(carValuationSuccess(response));
  } catch (error: any) {
    yield put(carValuationFailed(error));
  }
}

function* carValuationSagas() {
  yield all([takeLatest(carValuation, carValuationSaga)]);
}

export { carValuationSagas };
